import React from 'react'
import i18n from 'constants/strings'
import styles from './competitionMatchCard.module.scss'
import BtnWithChevron from 'components/generic/BtnWithChevron'
import { isPlayerHidden } from 'utils'
import { SideEnum } from 'types/api/enums'
import MatchCard, { MatchCardProps } from '../generic/MatchCard'

interface CompetitionMatchCardProps extends MatchCardProps {
  onClickH2H: (playerIds: [string, string]) => void
}

const CompetitionMatchCard = React.memo(
  ({
    match,
    profileViewedId,
    onClickH2H,
    truncateName = false,
    className = '',
  }: CompetitionMatchCardProps) => {
    const { sides } = match
    const isSinglesMatch = sides.SIDE1.length === 1 && sides.SIDE2.length === 1
    const [s1Key, s2Key]: SideEnum[] = sides.SIDE1.find(p => p.id === profileViewedId)
      ? [SideEnum.SIDE1, SideEnum.SIDE2]
      : [SideEnum.SIDE2, SideEnum.SIDE1]

    return (
      <MatchCard
        match={match}
        profileViewedId={profileViewedId}
        truncateName={truncateName}
        className={className}
        headerRight={
          isSinglesMatch && (
            <BtnWithChevron
              onClick={() => onClickH2H([sides[s1Key][0].id, sides[s2Key][0].id])}
              isDisabled={isPlayerHidden(sides[s2Key][0])}
              className={styles.linkH2h}
            >
              {i18n.t('strProfile.headToHead')}
            </BtnWithChevron>
          )
        }
      />
    )
  }
)

export default CompetitionMatchCard
